import { render, staticRenderFns } from "./RecommendSign.vue?vue&type=template&id=5db050a8&scoped=true"
import script from "./RecommendSign.vue?vue&type=script&lang=js"
export * from "./RecommendSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db050a8",
  null
  
)

export default component.exports